// bm-design-system: toast primitive (ported from FloorCore)
// Dark navy confirmation snackbar with an accent check. Host owns positioning.
import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ToastProps {
  message: React.ReactNode;
  className?: string;
}

export function Toast({ message, className }: ToastProps) {
  return (
    <div
      role="status"
      className={cn(
        "flex items-center gap-3 rounded-lg bg-ink-display px-4 py-3 text-sm font-medium text-page shadow-lg",
        "dark:border dark:border-hairline",
        className,
      )}
    >
      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent">
        <Check className="h-3 w-3 text-page" strokeWidth={3} />
      </span>
      {message}
    </div>
  );
}
